import { dealDetailParamsSchema } from '@/modules/product/deals/deals-search-schemas';
import { DealDetailModule } from '@/modules/product/deals/deal-detail/index';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/product/deals/$id')({
  params: {
    parse: params => dealDetailParamsSchema.parse(params),
    stringify: params => ({ id: String(params.id) }),
  },
  component: DealDetailModule,
});
